import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function EnquiryForm({ productName = "", onDone }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: productName ? `I'd love to know more about ${productName}.` : "",
  });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", { ...form, product_name: productName || null });
      toast.success("Enquiry received — our concierge will reach out shortly.");
      onDone && onDone();
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="enquiry-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <input required className="field" placeholder="Full name" value={form.name} onChange={set("name")} data-testid="enquiry-name" />
        <input required className="field" placeholder="Phone / WhatsApp" value={form.phone} onChange={set("phone")} data-testid="enquiry-phone" />
      </div>
      <input type="email" className="field" placeholder="Email (optional)" value={form.email} onChange={set("email")} data-testid="enquiry-email" />
      <textarea required rows={4} className="field resize-none" placeholder="Tell us about the piece or occasion…" value={form.message} onChange={set("message")} data-testid="enquiry-message" />
      <button type="submit" className="btn-gold w-full" disabled={busy} data-testid="enquiry-form-submit">
        {busy ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
}
